<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Completed Payment Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Completed Payment Details",
            items: [
               {
                  text: "Completed Payments",
                  href: "/doctor-payments/completed",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            completed: {},
            consultations: [],

            token: '',
            errors: {},

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchDetails();
      },


      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchDetails() {
            let url = "api/admin/doctor/payments/details?doctor_payment_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.completed = responseData.payment;  
               this.consultations = responseData.consultations;
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'payments.completed' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">                        
                        <b-card header-class="bg-transparent border-light" class="border border-light">  
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Payment Details</h4>                         
                           <b-row>
                              <b-col md="12">
                                 <h5>Doctor</h5>
                                 <p>Dr. {{completed.doctor_name}}<br>
                                    {{completed.country_code}} {{completed.mobile}}
                                 </p>

                                 <h5>Amount Paid</h5>
                                 <p>Rs. {{completed.amount_to_paid}}</p>

                                 <h5>Payment ID</h5>
                                 <p>{{completed.payment_id}}</p>

                                 <h5>Payment Notes</h5>
                                 <p>{{completed.payment_notes}}</p>

                                 <a :href="$image_url + completed.payment_image" target="_blank"><img :src="$image_url + completed.payment_image" alt=""></a>
                              </b-col>    
                           </b-row>
                           
                        </b-card>
                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Consultations</h4>
                           <b-row>
                              <b-col lg="6" class="payment-consultation" v-for="consultation in consultations" :key="consultation.id">
                                 <h5>Booking ID: {{consultation.booking_id}}</h5>
                                 <p>{{consultation.booking_date | formatDate}}, {{consultation.consultation_start | formatTime}} - {{consultation.consultation_end | formatTime}}<br>
                                    Amount to be Paid - Rs. {{consultation.amount_to_paid}}</p>
                              </b-col>  
                           </b-row>
                        </b-card>
                        <!-- end card -->                      
                     </div>
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

     
   </Layout>
</template>
